import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import "./App.css";
import Navbar from "./components/site/Navbar";
import Hero from "./components/site/Hero";
import About from "./components/site/About";
import CityChapters from "./components/site/CityChapters";
import ProfessionalCircles from "./components/site/ProfessionalCircles";
import Membership from "./components/site/Membership";
import FAQ from "./components/site/FAQ";
import Founder from "./components/site/Founder";
import Contact from "./components/site/Contact";
import Footer from "./components/site/Footer";
import HowItWorks from "./components/site/HowItWorks";
import CommunityGuidelines from "./pages/CommunityGuidelines";
import LegalPage from "./pages/LegalPage";
import Apply from "./pages/Apply";
import InternalViewer from "./pages/InternalViewer";
import Admin from "./pages/Admin";

function Home() {
  return (
    <div className="App font-sans bg-white text-black">
      <Navbar />
      <main>
        <Hero />
        <About />
        <CityChapters />
        <ProfessionalCircles />
        <div className="container-x" data-testid="divider-before-how-it-works"><div className="hairline" /></div>
        <HowItWorks />
        <div className="container-x" data-testid="divider-after-how-it-works"><div className="hairline" /></div>
        <Membership />
        <FAQ />
        <Founder />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

function ScrollToTopOnRouteChange() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    // If a valid element hash is present, scroll to that section instead
    // of forcing top. Retry a couple of frames for hydration.
    if (hash) {
      const id = hash.replace(/^#/, "");
      const tryScrollToHash = () => {
        const el = id ? document.getElementById(id) : null;
        if (el) {
          el.scrollIntoView({ behavior: "auto", block: "start" });
          return true;
        }
        return false;
      };
      if (tryScrollToHash()) return;
      requestAnimationFrame(() => {
        if (tryScrollToHash()) return;
        setTimeout(tryScrollToHash, 120);
        setTimeout(tryScrollToHash, 320);
      });
      return;
    }

    const top0 = () => {
      try { window.scrollTo(0, 0); } catch (e) { /* noop */ }
      try {
        document.documentElement.scrollTop = 0;
        if (document.body) document.body.scrollTop = 0;
      } catch (e) { /* noop */ }
    };
    top0();
    requestAnimationFrame(top0);
    setTimeout(top0, 60);
  }, [pathname, hash]);
  return null;
}

function App() {
  useEffect(() => {
    // Ensure page loads at the very top on cold navigation.
    if (typeof window !== "undefined") {
      try {
        if ("scrollRestoration" in window.history) {
          window.history.scrollRestoration = "manual";
        }
      } catch (e) {}
      if (!window.location.hash) {
        const top0 = () => {
          try { window.scrollTo(0, 0); } catch (e) {}
          try { document.documentElement.scrollTop = 0; document.body && (document.body.scrollTop = 0); } catch (e) {}
        };
        top0();
        requestAnimationFrame(top0);
        setTimeout(top0, 100);
        setTimeout(top0, 400);
      }
    }
    // NOTE: Apply-CTA clicks used to fire a Meta Pixel `Lead` here.
    // That was removed intentionally — a CTA click is not a meaningful
    // business conversion. `Lead` now fires from /apply only after the
    // application is successfully created in Atlas (see Apply.jsx →
    // trackLead in `lib/meta-pixel.js`). The base `PageView` is still
    // fired from public/index.html on every full page load and is not
    // touched here.
  }, []);

  return (
    <BrowserRouter>
      <ScrollToTopOnRouteChange />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/community-guidelines" element={<CommunityGuidelines />} />
        <Route path="/privacy" element={<LegalPage />} />
        <Route path="/terms" element={<LegalPage />} />
        <Route path="/refund" element={<LegalPage />} />
        <Route path="/apply" element={<Apply />} />
        <Route path="/internal/applications" element={<InternalViewer />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/admin/*" element={<Admin />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
